'use client';
import { useState } from 'react';
import { useApiStore } from '@/context/global/stores/apiStore';

import { TPlayList } from '@/context/global/types/playlist';

export function usePlayList() {
  const { API } = useApiStore();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchPlayList = async (): Promise<TPlayList | null> => {
    setLoading(true);
    setError(null);

    try {
      const response = await API.Page.Playlist();
      return response.data.responseObject;
    } catch (err) {
      const errorMessage =
        err instanceof Error ? err.message : 'เกิดข้อผิดพลาดในการดึงข้อมูลศิลปิน';
      setError(errorMessage);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    fetchPlayList,
    loading,
    error,
  };
}
